import { g as i, b as d, a as m, c as l, d as p } from "./gls-dynatrace-xhr-action-D5YBb2s5.js";
const n = (e) => {
  const t = document.createElement("script");
  t.src = `https://js-cdn.dynatrace.com/jstag/164ae1b51de/bf90494dmi/${e}_complete.js`, t.type = "text/javascript", t.setAttribute("crossOrigin", "anonymous"), document.head.appendChild(t);
}, c = (e, t, r, a) => {
  window.dtrum && window.dtrum.reportCustomError(e, t, r, a);
};
export {
  i as glsEnterDynatraceAction,
  d as glsEnterDynatraceXhrAction,
  n as glsInjectDynatrace,
  m as glsLeaveDynatraceAction,
  l as glsLeaveDynatraceXhrAction,
  p as glsMarkDynatraceXhrActionFailed,
  c as glsReportCustomDynatraceError
};
